import { DOCUMENT } from "@angular/common";
import { Injectable, inject } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { DESIGN_ICON_NAMESPACE, DESIGN_ICON_PATHS } from "./design-icons";

const VIEW_BOX = "0 0 24 24";
const STROKE_WIDTH = "1.8";

// Registers the design glyphs so <mat-icon svgIcon="rl:name"> renders them, inheriting currentColor.
@Injectable({ providedIn: "root" })
export class IconRegistry {
  private readonly registry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly document = inject(DOCUMENT);

  register(): void {
    for (const [name, path] of Object.entries(DESIGN_ICON_PATHS)) {
      this.registry.addSvgIconLiteralInNamespace(
        DESIGN_ICON_NAMESPACE,
        name,
        this.sanitizer.bypassSecurityTrustHtml(this.svg(path))
      );
    }
  }

  // Input is a generated constant, never user data; escaped regardless.
  private svg(path: string): string {
    const el = this.document.createElement("div");
    el.textContent = path;
    const safePath = el.innerHTML;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${VIEW_BOX}" fill="none" ` +
      `stroke="currentColor" stroke-width="${STROKE_WIDTH}" stroke-linecap="round" ` +
      `stroke-linejoin="round" aria-hidden="true"><path d="${safePath}"/></svg>`;
  }
}
